import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ProductCard from './ProductCard';
import LoadMoreProductsContainer from '../Containers/LoadMoreProductsContainer';

const CategoryProductsView = () => {
  const { productsWrapper, isLoading } = useSelector((state) => state.productsView);
  const filters = useSelector((state) => state.facetedSearch.facetFilters);
  const allSelectedOptions = useMemo(() => {
    return filters.reduce((accumulator, filter) => {
      if (Array.isArray(filter.selectedOptions) && filter.selectedOptions.length > 0) {
        const { id, selectedOptions } = filter;
        accumulator[id] = selectedOptions;
      }
      return accumulator;
    }, {});
  }, [filters]);
  const { products, pagination, categorySystemId } = productsWrapper;
  const type = categorySystemId ? 'category' : 'search';

  const productsRender = useMemo(
    () =>
      products.map((product) => (
        <li
          className="product-list__item"
          key={product.id + 'categoryproductcard'}
        >
          <ProductCard {...product} />
        </li>
      )),
    [products]
  );
  return (<>
    <ul className="product-list">
      {productsRender}
    </ul>
    <div className="load-more-products">
      <LoadMoreProductsContainer {...pagination} identifier={categorySystemId} type={type} products={productsWrapper} filters={allSelectedOptions} />
    </div>
  </>)

};
export default CategoryProductsView;
